var _desc, _defs, _rect, _rect2, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEccv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 160",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "ECCV logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Clean ECCV conference wordmark badge")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge",
    x1: 20,
    x2: 220,
    y1: 26,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1d4ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2563eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f766e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 236,
    height: 120,
    rx: 22,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 236,
    height: 120,
    rx: 22,
    fill: "none",
    stroke: "#dbeafe",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 40h208",
    stroke: "url(#badge)",
    strokeLinecap: "round",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 108,
    fill: "#111827",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 86,
    fontWeight: 900,
    letterSpacing: -6,
    textAnchor: "middle"
  }, "ECCV")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEccv);
export default __webpack_public_path__ + "static/media/ECCV.99ef2a02a5e020c605962cca06bfaac3.svg";
export { ForwardRef as ReactComponent };